import { Avatar, Box, Divider, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Loading from "../Loading/Loading";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";

interface Props {
  loadingPatient: boolean;
  patient: any;
  genderLabel: string;
  age: string;
}

export default function PatientSidebar({
  loadingPatient,
  patient,
  genderLabel,
  age
}: Props) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: "260px",
        flexShrink: 0,
        bgcolor: semanticColors.surface.canvas,
        borderRadius: "20px",
        boxShadow: "0px 0px 8px rgba(30,39,79,0.10)",
        p: "24px",
        position: "sticky",
        top: "148px"
      }}
    >
      {loadingPatient ? (
        <Box display="flex" justifyContent="center" py={4}>
          <Loading />
        </Box>
      ) : patient ? (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: 2
            }}
          >
            <Avatar
              src={patient.pictureUrl}
              alt={patient.name}
              sx={{
                width: 80,
                height: 80,
                border: `3px solid ${semanticColors.action.primary}`,
                mb: 1.5
              }}
            />
            <Typography
              sx={{
                ...typography.body.lBold,
                color: semanticColors.text.primary,
                textTransform: "uppercase",
                textAlign: "center"
              }}
            >
              {patient.name}
            </Typography>
          </Box>
          <Divider sx={{ mb: 1.5 }} />
          {[
            { label: t("clinicalRecords.sex"), value: genderLabel || "-" },
            {
              label: t("clinicalRecords.age"),
              value: age ? `${age} ${t("utentes.years")}` : "-"
            },
            { label: t("patientDetail.nhsId"), value: patient.nhsId ?? "-" }
          ].map(({ label, value }) => (
            <Box
              key={label}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: "6px"
              }}
            >
              <Typography
                sx={{
                  ...typography.body.m,
                  color: semanticColors.text.secondary
                }}
              >
                {label}
              </Typography>
              <Typography
                sx={{
                  ...typography.body.mBold,
                  color: semanticColors.text.primary,
                  textAlign: "right"
                }}
              >
                {value}
              </Typography>
            </Box>
          ))}
        </>
      ) : null}
    </Box>
  );
}
